(function() {

	var cartItemQuantity = '.js-cart-item-quantity';
	var $cartItemQuantity = $(cartItemQuantity);
	var cartItemRefresh = '.js-cart-item-refresh';
	var $cartItemRefresh = $(cartItemRefresh);
	var colExtra = '.js-col-extra';
	var $colExtra = $(colExtra);
	var colQty = '.js-col-qty';
	var $colQty = $(colQty);

	//	======================================================================  //
	//	Functions
	//	======================================================================  //

	/**
	 * @function `showRefreshButton`
	 *
	 * Shows the refresh button to the user when the value of the select button
	 * (quantity) is updated.
	 *
	 * [1]. Check if value is a number > 0, if false force field value to (int) 1
	 */
	function showRefreshButton() {
		var $select = $(this);
		var selectVal = parseInt($select.val());
		var maxQty = $select.attr('max');

		if (isNaN(selectVal) || selectVal === 0 || selectVal === "") { /* [1] */
			$select.val(1);
		} else if (selectVal > maxQty) {
			alert('There are only ' + maxQty + ' items left.');
			$select.val(maxQty);
		}

		$select.closest('form').find(cartItemRefresh).show();
		$select.closest(colQty).next(colExtra).hide();
	}

	/**
	 * @function `hideRefreshButtons`
	 *
	 * Hides all refresh buttons through the document.
	 */
	function hideRefreshButtons() {
		$cartItemRefresh.hide();
		$colExtra.show();
	}

	// ======================================================================  //
	//  On change
	//  ======================================================================  //

	$cartItemQuantity.on('change', showRefreshButton);

	// ======================================================================  //
	//  On ready
	//  ======================================================================  //

	onReady.callbacks.cartItemQuantity = hideRefreshButtons;

})();
